import Link from 'next/link';
import { IBreadcrumbStep } from '@typescript/index';
import styles from '@components/Breadcrumbs/Breadcrumbs.style';
import Icon from '@components/icons/Icon';
import theme from '@styles/theme';
type ItemProps = {
  step: IBreadcrumbStep;
  index: number;
  isLast: boolean;
  isActive: boolean;
  onMouseEnter: () => void;
  onMouseLeave: (event: React.MouseEvent) => void;
  onClick: (event: React.MouseEvent) => void;
};
const BreadcrumbItem = ({
  step,
  index,
  isLast,
  isActive,
  onMouseEnter,
  onMouseLeave,
  onClick
}: ItemProps): JSX.Element => <nav key={`breadcrumb-${step.id}`} role="menubar" aria-label="Breadcrumbs" sx={styles.breadcrumb} data-cy="BreadcrumbsStep" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
    {index ? <span sx={styles.divider}>/</span> : null}
    <div sx={styles.breadcrumbContent} className={`breadcrumb-${step.id}`}>
      {step.href ? <>
          <Link href={step.href} sx={styles.breadcrumbLink(isActive, isLast)}>
            {step.name}
          </Link>
          <button sx={styles.breadcrumbLinkMobile(isActive, isLast)} onClick={onClick} type="button">
            {step.name}
          </button>
        </> : <span sx={styles.breadcrumbInactive(isActive, isLast)}>{step.name}</span>}
      {step.siblings && step.siblings.length > 0 && <button sx={styles.chevronContainer} onClick={onClick} type="button">
          <Icon icon={isActive ? 'ChevronRight' : 'ChevronLeft'} addSx={styles.chevronIcon} size="16px" color={theme.rawColors.darkGrey300} />
        </button>}
    </div>
  </nav>;
export default BreadcrumbItem;